import { IconKey } from '../../Icons/index';

export enum ItemId {
  Dashboard = '/organizations/:organizationId/dashboard',
  Reporting = '/organizations/:organizationId/reporting',
  Home = '/home',
  Tasks = '/tasks',
  Users = '/users',
  NeedsOutreach = '/needs-outreach',
  Students = '/organizations/:organizationId/students',
  Referrals = '/organizations/:organizationId/referrals',
  Appointments = '/appointments',
  Verification = '/verification',
  Activity = '/activity',
  CrisisReports = '/crisisreports',
  Settings = '/settings',
  Providers = '/providers',
  Staff = '/organizations/:organizationId/staff',
  Organizations = '/organizations',
  Messaging = '/messages',
  Debug = '/debug',
  Config = '/config',
  Handbook = '/organizations/:organizationId/handbook',
  Utilization = '/organizations/:organizationId/utilization',
  Announcements = '/organizations/:organizationId/updates',
  ConnectNowCallReports = '/connectnow-reports',
  Iop = '/iop',
  Beacon = '/beacon',
}

export const iconMap: Record<ItemId, IconKey> = {
  [ItemId.Activity]: 'iconsNavClaimsActiveSvg',
  [ItemId.Announcements]: 'iconsNavCampusUpdatesSvg',
  [ItemId.Appointments]: 'iconsNavApptActiveSvg',
  [ItemId.Config]: 'iconsSettingsActiveSvg',
  [ItemId.ConnectNowCallReports]: 'iconsCheckWhiteSvg',
  [ItemId.CrisisReports]: 'iconsWarningSvg',
  [ItemId.Dashboard]: 'iconsNavHomeActiveSvg',
  [ItemId.Debug]: 'iconsSettingsActiveSvg',
  [ItemId.Handbook]: 'iconsNavResourcesActiveSvg',
  [ItemId.Home]: 'iconsNavHomeActiveSvg',
  [ItemId.Iop]: 'iconsNavReferralsActiveSvg',
  [ItemId.Messaging]: 'iconsNavMessagesActiveSvg',
  [ItemId.NeedsOutreach]: 'iconsNavFlagSvg',
  [ItemId.Organizations]: 'iconsNavOrganizationsActiveSvg',
  [ItemId.Providers]: 'iconsNavProvidersActiveSvg',
  [ItemId.Referrals]: 'iconsNavReferralsActiveSvg',
  [ItemId.Reporting]: 'iconsBarChartSvg',
  [ItemId.Settings]: 'iconsSettingsActiveSvg',
  [ItemId.Staff]: 'iconsNavProvidersActiveSvg',
  [ItemId.Students]: 'iconsNavPatientsActiveSvg',
  [ItemId.Tasks]: 'iconsNavClipboardSvg',
  [ItemId.Users]: 'iconsNavPatientsActiveSvg',
  [ItemId.Utilization]: 'iconsNavEyeSvg',
  [ItemId.Verification]: 'iconsNavVerificationActiveSvg',
  [ItemId.Beacon]: 'iconsNavBeaconActiveSvg',
};

export const allItems = [
  {
    title: 'Home',
    itemId: ItemId.Home,
  },
  {
    title: 'Dashboard',
    itemId: ItemId.Dashboard,
  },
  {
    title: 'Beacon',
    itemId: ItemId.Beacon,
  },
  {
    title: 'Tasks',
    itemId: ItemId.Tasks,
  },
  {
    title: 'Students',
    itemId: ItemId.Students,
  },
  {
    title: 'Referrals',
    itemId: ItemId.Referrals,
  },
  {
    title: 'Patients',
    itemId: ItemId.Users,
  },
  {
    title: 'Needs Outreach',
    itemId: ItemId.NeedsOutreach,
  },
  {
    title: 'Staff',
    itemId: ItemId.Staff,
  },
  {
    title: 'IOP',
    itemId: ItemId.Iop,
  },
  {
    title: 'Reporting',
    itemId: ItemId.Reporting,
  },
  {
    title: 'Utilization',
    itemId: ItemId.Utilization,
  },
  {
    title: 'Providers',
    itemId: ItemId.Providers,
  },
  {
    title: 'Organizations',
    itemId: ItemId.Organizations,
  },
  {
    title: 'Appointments',
    itemId: ItemId.Appointments,
    divider: true,
  },
  {
    title: 'Messages',
    itemId: ItemId.Messaging,
  },
  {
    title: 'Handbook',
    itemId: ItemId.Handbook,
  },
  {
    title: 'Campus Updates',
    itemId: ItemId.Announcements,
  },
  {
    title: 'ID Verification',
    itemId: ItemId.Verification,
    divider: true,
  },
  {
    title: 'Activity',
    itemId: ItemId.Activity,
  },
  {
    title: 'ConnectNow Reports',
    itemId: ItemId.ConnectNowCallReports,
  },
  {
    title: '24/7 Crisis Reports',
    itemId: ItemId.CrisisReports,
  },
  {
    title: 'Settings',
    itemId: ItemId.Settings,
  },
  {
    title: 'Debug',
    itemId: ItemId.Debug,
  },
  {
    title: 'Config',
    itemId: ItemId.Config,
  },
];

// Supporting clinicians should maintain the mcp view, but have a more limited
// set of items that they have access to. We can expand upon this in the future
// if other roles follow a similar pattern.
export const visibleSupportingClinicianItems = new Set<ItemId>([
  ItemId.Dashboard,
  ItemId.Students,
  ItemId.Messaging,
  ItemId.Settings,
]);
